module.exports = __webpack_public_path__ + "static/media/halloween3.6f82e743.jpg";